import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type {
  EmptySearchState,
  NearestDepartures,
  RecommendedCountries,
  EmptyRegionAction,
} from './types';

import { CHANGE_SEARCH_PARAMS } from '../../constants/search';

export const NUMBER_HOTELS_ADDED = 3;

const initialState: EmptySearchState = {
  visibleHotelsOtherRegion: NUMBER_HOTELS_ADDED,
  isEmptySearch: false,
  emptyRegionNameRu: null,
  nearestDepartures: [],
  recommendedCountries: [],
};

const emptySearch = createSlice({
  name: 'emptySearch',
  initialState,
  reducers: {
    visibleHotelsOtherRegionAction: (state, action: PayloadAction<number>) => {
      state.visibleHotelsOtherRegion = action.payload;
    },
    setIsEmptySearch: (state) => {
      state.isEmptySearch = true;
    },
    setEmptyRegion: (state, action: PayloadAction<EmptyRegionAction>) => ({
      ...state,
      ...action.payload,
    }),
    setNearestDepartures: (state, action: PayloadAction<NearestDepartures>) => {
      state.nearestDepartures = action.payload;
    },
    setRecommendedCountries: (
      state,
      action: PayloadAction<RecommendedCountries>,
    ) => {
      state.recommendedCountries = action.payload;
    },
  },
  extraReducers: {
    [CHANGE_SEARCH_PARAMS]: () => initialState,
  },
});

export const {
  visibleHotelsOtherRegionAction,
  setIsEmptySearch,
  setEmptyRegion,
  setNearestDepartures,
  setRecommendedCountries,
} = emptySearch.actions;

export const { name: emptySearchName } = emptySearch;

export default emptySearch.reducer;
